import { NavigationTab } from 'shared/model';

import { AddBonusProgramButton } from './buttons';

export const TABS: Array<NavigationTab> = [
  {
    key: 'bonus-programs',
    path: '',
    label: 'Список программ',
    buttons: [
      {
        element: <AddBonusProgramButton />,
        controller: 'BonusService',
        right: 'Write',
      },
    ],
  },
];
